import React, { useReducer } from "react";
import { Button, Modal, Icon, Label } from "semantic-ui-react";
import FilesUpload from "./FilesUpload";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";
import { selectCounters } from "../../../features/counter/counterSlice";
import { useSelector } from "react-redux";

function Note(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const CountersState = useSelector(selectCounters);
  return (
    <>
      {/* <Button className="marginLeftClass" color='black' onClick={() => dispatch({ type: ACTION.OPEN, size: 'tiny' })}>Documents</Button> */}
      {/* <Button className="marginLeftClass" color='black' onClick={() => dispatch({ type: ACTION.OPEN, size: 'tiny' })}>Documents</Button> */}
      {/* <Popup
        content="Les Documents du patient"
        trigger={
          // <Button  className="marginLeftClass" color="blue" >
          <> */}
      <Icon
        circular
        inverted
        color="orange"
        // floated="right"
        onClick={() => dispatch({ type: ACTION.OPEN, size: "tiny" })}
        name="folder open"
        size="large"
        className="centerIcon_And_Float_RightMod"
      />
      {CountersState.UploadCounter > 0 ? (
        <Label className="notificationCounter" color="red" floating>
          {CountersState.UploadCounter}
        </Label>
      ) : null}

      {/* </>
          // </Button>
        } */}
      {/* /> */}
      <Modal
        size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      >
        <Modal.Header className="center3columnheaders">Documents</Modal.Header>
        <Modal.Content>
          <FilesUpload />
        </Modal.Content>
        <Modal.Actions>
          <Button color="blue" onClick={() => dispatch({ type: ACTION.CLOSE })}>
            Retour
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Note;
